module.exports = __webpack_public_path__ + "img/isfj.68333c9a.png";